export default __webpack_public_path__ + "static/frn-uhc-logo-d6cf3bb7.svg";